<template>
  <div>
    <div class="choose-box">
      <span @click="showSkuMats" class="btn">请选择</span>

      <div>
        <!-- <ul slot="content">
          <li
            style="padding: 2px 0;height: 60px;overflow-y: auto;"
            v-for="item in value"
            :key="item.firstCategoryName+item.secondCategoryName+item.categoryName"
            :title="item.firstCategoryName+item.secondCategoryName+item.categoryName"
          >
          2
            {{ item.firstCategoryName+item.secondCategoryName+item.categoryName }}
          </li>
        </ul> -->
        <ul
          class="value-box"
          style="
            padding: 2px 5px;
            height: 100px;
            overflow-y: auto;
            border: 1px solid #ccc;
          "
        >
          <li v-for="(item, i) in value" :key="i">
            {{ item.firstCategoryName + ">" + item.secondCategoryName
            }}{{ item.categoryName ? "> " + item.categoryName : "" }}
          </li>
          <!-- <li v-if="value.length > 5" style="height: 15px; line-height: 15px">
            ...
          </li> -->
        </ul>
      </div>
    </div>
    <!-- <materialDirectory
      :dialogVisible.sync="visible"
      @selectedUserSuccess="handleTrue"
      :type="1"
    /> -->
    <dialog-multi-checkbox-group
      :defaultPitchOn="defaultPitchOn"
      :dialogVisible.sync="visible"
      @determine="determine"
      @refdata="refdata"
    >
    </dialog-multi-checkbox-group>
  </div>
</template>

<script>
// import materialDirectory from "./materialDirectory";
import dialogMultiCheckboxGroup from "./dialog-multi-checkbox-group";
export default {
  name: "chooseMaterialDirectory",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      defaultPitchOn: [],
    };
  },

  components: {
    // materialDirectory,
    dialogMultiCheckboxGroup,
  },

  computed: {},

  beforeMount() {},

  mounted() {},

  methods: {
    determine(row) {
      console.log("🚀 ~ determine ~ row:", row);
      const result = row.map(
        ({
          firstCategoryCode,
          firstCategoryName,
          secondCategoryCode,
          secondCategoryName,
          thirdCategoryCode,
          thirdCategoryName,
        }) => ({
          firstCategoryCode,
          firstCategoryName,
          secondCategoryCode,
          secondCategoryName,
          categoryCode: thirdCategoryCode || "",
          categoryName: thirdCategoryName || "",
        })
      );
      console.log("result:", result);
      this.$emit("update:value", result);
      this.$emit("reValidatorShopBusinessCategoryScopeBOS");
    },
    refdata() {},

    showSkuMats() {
      this.visible = !this.visible;
    },
    handleTrue(row) {
      const result = row.map(({ id, name, matcateryLevel }) => ({
        matCode: id,
        matName: name,
        level: matcateryLevel,
      }));
      this.$emit("update:value", result);
    },
  },

  watch: {},
};
</script>
<style lang="scss" scoped>
.choose-box {
  .value-box {
    li {
      height: 24px;
      line-height: 28px;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
    }
  }
  .btn {
    color: #0089ef;
    cursor: pointer;
    // line-height: 20px;
  }
}
</style>
